<template>
  <div style="margin-top: 1%; padding-bottom: 2%">
    <h3>Maruti Suzuki open to partnerships to secure supply chain</h3>
    NEW DELHI: Maruti Suzuki is open to forming partnerships with auto part
    makers to secure its future supply chain and maintain its leadership
    position, the chairman of India’s top-selling carmaker said in an interview.
    Partnering with suppliers in its early years contributed significantly to
    Maruti’s success in India, where it has 43 per cent share of the car market,
    and also helped establish a supply chain for combustion engine cars, R C
    Bhargava told Reuters. With growing demand for more technology in cars and a
    shift to ‘greener’ powertrains like electric and hybrid, automotive supply
    chains globally are changing and need large investments to keep pace. “If
    required somewhere, we will get into a joint venture,” said Bhargava, when
    asked what role Maruti would play in setting up and securing its future
    supply chain. The company, though, is yet to identify specific areas for an
    alliance, he said.<br /><br />

    <h3>Energy crisis pushes worldwide return to nuclear power</h3>
    PARIS: As the costs of importing energy soars worldwide and climate crises
    wreak havoc, interest in nuclear power is on the rise with nations
    scrambling to find alternative sources.Investment in nuclear power declined
    after Japan’s 2011 Fukushima disaster, the world’s worst nuclear accident
    since Chernobyl in 1986, as fears over its safety increased and governments
    ran scared.But following Moscow’s invasion of Ukraine in February, the
    subsequent squeeze on energy supplies and Europe’s push to wean itself off
    of Russian oil and gas, the tide is now turning back in favour of
    nuclear.Governments face difficult decisions with rising gas and electricity
    bills and scarce resources threatening to cause widespread suffering this
    winter.Some experts argue that nuclear power should not be considered an
    option, but others argue that it must remain part of the world’s energy
    mix.<br /><br />

    <h3>
      Construction company "Pinnacle Construction" bankrupt after months of
      litigation
    </h3>
    PORTLAND : After being sued for a serious construction accident in January
    2022, construction company Pinnacle Construction has been unable to land any
    profitable contracts. The plaintiff is Nadir Ltd., which had contracted
    Pinnacle Construction to build a new administration building in Gulberg. In
    an accident involving a construction crane, an employee of Nadir Ltd. who
    was on the site to inspect the progress of the construction work was
    seriously injured and was taken to Jinnah Hospital. The company has now been
    ordered in court to pay a fine in the large millions. As the court case has
    been regularly reported in the media, the number of Pinnacle Construction's
    customers has dropped so much that the company went bankrupt last week.<br /><br />

    <h3>ECB needs ‘significant’ rate hike in September: Villeroy</h3>
    JACKSON HOLE: The European Central Bank (ECB) needs another significant
    interest rate hike in September and should hit the “neutral” level before
    the end of the year, French central bank chief Francois Villeroy de Galhau
    said on Saturday.The ECB raised rates by 50 basis points to zero in July to
    fight inflation that is now approaching double-digit territory and another
    such move is now fully priced in by financial markets.Considered a centrist
    on the bank’s rate-setting Governing Council, Villeroy said that rates
    should keep rising until the ECB hits the neutral level, which is somewhere
    between 1 per cent and 2pc. At the neutral rate, the central bank neither
    stimulates nor holds back growth.“We could be there before the end of the
    year, after another significant step in September,” Villeroy told the US
    Federal Reserve’s Jackson Hole Economic Symposium.
  </div>
</template>

<script>
import "./styles.css";

export default {
  props: {
    parentFunction: Function,
  },
};
</script>
